<template>
  <div>
    <menubar :permission="permission"/>
    <div id="contact" class="container">
      <div id="title" class="d-flex justify-content-start">
        <img src="/img/05_slash.svg" />
        <p class="h1">マニュアル</p>
      </div>
      <p>JVTAのマニュアルは下記からダウンロード下さい。</p>
      <!-- object data, a href に資料を配置しているパスに変更してください -->
      <div class="preview">
        <object data="data/manual.pdf">
          <a href="data/manual.pdf" class="btn-purple">資料をダウンロード</a>
        </object>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<style lang="css" scoped>
body {
  background-color: #fffbf9;
}
p,
.preview {
  color: #666666;
}
object {
  width: 100%;
  height: 80vh;
  padding-bottom: 3rem;
}
#title {
  margin: 3rem 0;
}
#title img {
  width: 3rem;
  height: 3rem;
}
#title p {
  color: #666666;
  padding: 0;
}
.container {
  min-height: 80vh;
}
p > img {
  width: 3rem;
  height: 3rem;
}

a {
  font-size: 1.25rem;
  text-decoration: none;
  width: 20rem;
  display: block;
  text-align: center;
  line-height: 3rem;
  border-radius: 1rem;
  border: 0.25rem solid #763fd0;
}

a:hover {
  background-color: #fffbf9;
  color: #763fd0;
  cursor: pointer;
}
</style>

<script>
import { defineComponent } from "vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";

export default defineComponent({
  components: { menubar, footerComponent },
  props: {
    permission:String,
  },
});
</script>